<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <!-- <topPiece></topPiece> -->
      <div class="container" v-if="list.length > 0">
        <div class="content_wrap">
          <titleConfig
            v-if="false"
            :title="langSet == 'cn' ? list[0].name : list[0].name_en"
            :type="2"
          ></titleConfig>
          <newTitle
            v-if="list[0].name"
            :title="langSet == 'cn' ? list[0].name : list[0].name_en"
          ></newTitle>
          <div class="main_content">
            <div class="img_wrap" v-if="list[0].imgs.length > 0">
              <img
                v-for="(_item, _index) in list[0].imgs"
                :key="_index"
                class="content_img"
                :src="_item"
                alt=""
              />
            </div>
            <div
              v-html="langSet == 'cn' ? list[0].content : list[0].content_en"
              class="content_richtext"
            ></div>
          </div>
        </div>
        <div class="join_btn" @click="toLink">
          {{ langSet == "cn" ? "参展申请" : "Exhibition Application" }}
        </div>
        <div class="special_title">
          <titleConfig
            :title="
              langSet == 'cn' ? '为什么选择2026 CDS' : 'Why Choose CDS 2026'
            "
            :type="2"
          ></titleConfig>
          <img
            src="https://oss.chinadentalshow.com/resource/image/pc/yaya%26%E5%87%8C%E5%B0%8F%E7%89%99-%E6%8A%B1%E7%9D%80%20(1).png"
            alt=""
          />
        </div>
        <div
          v-html="langSet == 'cn' ? list[1].content : list[1].content_en"
          class="content_richtext single"
        ></div>
        <!-- <div class="main_content">
          <div class="img_wrap" v-if="item.imgs.length > 0">
            <img
              v-for="(_item, _index) in item.imgs"
              :key="_index"
              class="content_img"
              :src="_item"
              alt=""
            />
          </div>
          <div v-html="langSet == 'cn' ? item.content : item.content_en"></div>
        </div> -->
        <!-- 2026.07.01 cds改版，隐藏 -->
        <!-- <div class="profile_wrap flex flex_wrap" ref="scrollProfile">
          <div class="profile_list flex flex_wrap flex_content_sb">
            <div
              class="profile_item flex"
              v-for="(item, index) in numList"
              :key="index"
            >
              <img :src="item.icon" alt="" />
              <div class="pro_text">
                <p class="num">
                  <count-to
                    v-if="showNum"
                    :start-val="0"
                    :end-val="item.num"
                    :duration="2000"
                  ></count-to>
                  <span v-else>{{ item.num }}</span>
                  <span class="text" v-if="index == 0">{{
                    langSet == "cn" ? "天" : "day"
                  }}</span>
                  <span class="text" v-if="index == 1">+</span>
                  <span class="text" v-if="index == 2">m²</span>
                  <span class="text" v-if="index == 3">{{
                    langSet == "cn" ? "天" : "day"
                  }}</span>
                  <span class="text" v-if="index == 5">+</span>
                  <span class="text" v-if="index == 6">+</span>
                  <span class="text" v-if="index == 7">+</span>
                </p>
                <p>{{ langSet == "cn" ? item.title : item.en_title }}</p>
              </div>
            </div>
          </div>
          <div class="right">
            <img :src="require('../../assets/imgs/join_img1.jpeg')" alt="" />
            <img :src="require('../../assets/imgs/join_img2.jpeg')" alt="" />
          </div>
        </div> -->
        <titleConfig
          :title="langSet == 'cn' ? '展商类型' : 'Exhibitor type'"
          :type="2"
        ></titleConfig>
        <div class="list_wrap flex flex_wrap">
          <template v-for="(item, index) in listA">
            <p
              class="flex flex_items_center flex_content_center"
              v-if="item.is_show == 1"
              :key="index"
            >
              {{ langSet == "cn" ? item.title : item.title_en }}
            </p>
          </template>
        </div>
        <titleConfig
          :title="langSet == 'cn' ? '观众类型' : 'Our Visitors'"
          :type="2"
        ></titleConfig>
        <div class="list_wrap flex flex_wrap">
          <template v-for="(item, index) in listB">
            <p
              class="flex flex_items_center flex_content_center"
              v-if="item.is_show == 1"
              :key="index"
            >
              {{ langSet == "cn" ? item.title : item.title_en }}
            </p></template
          >
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
// import topPiece from "@/components/topPiece.vue";
import newTitle from "@/components/new_title.vue";
import titleConfig from "@/components/title.vue";
import countTo from "vue-count-to";
import { webAbout, webExhibitionType, getWebsite } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    //topPiece,
    newTitle,
    titleConfig,
    // countTo,
  },
  data() {
    return {
      langSet: "",
      list: [],
      showNum: false,
      numList: [
        {
          icon: require("../../assets/imgs/p_icon4.png"),
          title: "展览",
          en_title: "Exhibition",
          num: "0",
        },
        {
          icon: require("../../assets/imgs/p_icon3.png"),
          title: "专业观众",
          en_title: "Visitors",
          num: "0",
        },
        {
          icon: require("../../assets/imgs/p_icon1.png"),
          title: "展览和会议活动面积",
          en_title: "Exhibition and Congress area",
          num: "0",
        },
        {
          icon: require("../../assets/imgs/p_icon8.png"),
          title: "学术会议",
          en_title: "Scientific programme",
          num: "0",
        },
        {
          icon: require("../../assets/imgs/p_icon5.png"),
          title: "会议活动",
          en_title: "Conference & Events",
          num: "0",
        },
        {
          icon: require("../../assets/imgs/p_icon2.png"),
          title: "参展企业",
          en_title: "Exhibiting companies",
          num: "0",
        },
        // {
        //   icon: require("../../assets/imgs/p_icon6.png"),
        //   title: "国际演讲嘉宾",
        //   en_title: "worldwide speakers",
        //   num: "0",
        // },
        // {
        //   icon: require("../../assets/imgs/p_icon7.png"),
        //   title: "国内演讲嘉宾",
        //   en_title: "national speakers",
        //   num: "0",
        // },
      ],
      webData: {},
      listA: [],
      listB: [],
      link: "",
      link_en: "",
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.10 获取我要参展内容 dxm
    // 1:展会介绍
    // 2:主办方
    // 3:观众参展
    // 4:住宿信息
    // 5:到达场馆
    // 6:口腔大会
    // 7:展商参展
    this.getWebAbout(7);
    //25.6.10 获取页面配置 dxm
    this.getWebsiteData("exhibition");
    //25.6.10 获取参展类型 1:展商类型  2:观众类型 dxm
    this.getWebExhibitionType(1);
    this.getWebExhibitionType(2);
    // 25.6.11 滑动到指定元素，数字动画效果 dxm
    this.$nextTick(() => {
      window.addEventListener("scroll", this.scroll, true);
    });
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    // 25.6.11 滑动到指定元素，数字动画效果 dxm
    scroll() {
      const el = this.$refs.scrollProfile;
      if (el) {
        var top = el.getBoundingClientRect().top; // 元素顶端到可见区域顶端的距离
        var se = document.documentElement.clientHeight; // 浏览器可见区域高度。
        if (!this.showNum && top < se) {
          this.showNum = true;
        }
      }
    },
    async getWebAbout(type) {
      let data = {
        type,
      };
      const res = await webAbout(data);
      this.list = res.data.lists;
      console.log(res.data.lists, 13123);
    },
    async getWebsiteData(type) {
      let data = {
        type,
      };
      const res = await getWebsite(data);
      let datas = res.data;
      this.numList[0].num = datas.exhibition_days;
      this.numList[1].num = datas.audience_num;
      this.numList[2].num = datas.area;
      this.numList[3].num = datas.meeting_days;
      this.numList[4].num = datas.representative;
      this.numList[5].num = datas.company_num;
      // this.numList[6].num = datas.international_guests;
      // this.numList[7].num = datas.domestic_guests;
      this.link = datas.exhibition_application_url;
      this.link_en = datas.exhibition_application_url_en;
    },
    async getWebExhibitionType(type) {
      let data = {
        type,
      };
      const res = await webExhibitionType(data);
      if (type == 1) {
        this.listA = res.data.lists;
      } else {
        this.listB = res.data.lists;
      }
    },
    toLink() {
      window.open(this.langSet == "cn" ? this.link : this.link_en, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  .main_content {
    padding: 40px 0 60px;
    font-size: 18px;
    color: #000;
    line-height: 28px;
    .img_wrap {
      margin-left: calc(-100vw / 2 + 50%);
      margin-right: calc(-100vw / 2 + 50%);
      width: 100vw;
      margin-bottom: 20px;
      .content_img {
        width: 100vw;
        height: auto;
      }
    }
  }
}
.profile_wrap {
  padding-top: 40px;
  .profile_list {
    width: 55%;
    .profile_item {
      font-weight: 600;
      font-size: 21px;
      color: #004190;
      line-height: 29px;
      margin-bottom: 50px;
      width: 50%;
      img {
        width: 40px;
        height: 40px;
        margin-top: 15px;
        margin-right: 10px;
      }
      .pro_text {
        width: 90%;
      }
      .num {
        font-family: Arial, Arial;
        font-weight: 900;
        font-size: 50px;
        color: #e62344;
        line-height: 70px;
        .text {
          margin-left: -12px;
        }
      }
    }
  }
  .right {
    width: 45%;
    > img {
      width: 100%;
      margin-bottom: 24px;
    }
  }
}

.list_wrap {
  padding: 40px 0;
  p {
    width: calc((100% - 81px) / 4);
    height: 44px;
    color: #fff;
    font-size: 18px;
    margin: 0 27px 20px 0;
    text-align: center;
    line-height: 22px;
    background: #0f3481;
    border-radius: 8px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.join_btn {
  width: 228px;
  height: 50px;
  color: #fff;
  background-color: #cf121b;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  margin: 30px auto 70px;
  border-radius: 40px;
}
.special_title {
  position: relative;
  z-index: 9;
  margin-bottom: 40px;
  img {
    width: 354px;
    height: 268px;
    display: block;
    position: absolute;
    right: 60px;
    bottom: -10px;
    z-index: 1;
  }
}
.content_richtext {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  // word-break: keep-all;
  word-break: break-all;
  // word-wrap: break-word;;
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain;
    display: block;
  }
}
.content_richtext.single {
  margin-bottom: 70px;
}
@media only screen and (max-width: 1280px) {
  .list_wrap p {
    font-size: 16px;
  }
  .profile_wrap .profile_list .profile_item .num {
    font-size: 46px;
  }
  .special_title {
    position: relative;
    z-index: 9;
    margin-bottom: 40px;
    img {
      width: 176px;
      height: 134px;
      display: block;
      position: absolute;
      right: 20px;
      bottom: 0px;
      z-index: 1;
    }
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    .main_content {
      display: block;
      font-size: 0.27rem;
      line-height: 0.42rem;
      padding: 0.38rem 0 1.15rem;
      .content_img {
        width: 3.08rem;
        margin-right: 0;
        margin-bottom: 0.38rem;
      }
    }
  }
  .profile_wrap {
    display: block;
    padding-top: 0.56rem;
    .profile_list {
      width: 100%;
      .profile_item {
        width: 100%;
        font-size: 0.31rem;
        margin-bottom: 0.29rem;
        img {
          width: 0.58rem;
          height: 0.58rem;
          margin-right: 0.19rem;
          margin-top: 0.05rem;
        }
        .num {
          font-size: 0.54rem;
          line-height: 0.77rem;
          .text {
            margin-left: -6px;
          }
        }
      }
    }
    .right {
      width: 100%;
    }
  }
  .list_wrap {
    display: block;
    padding: 0.38rem 0;
    p {
      width: 100%;
      height: 0.88rem;
      font-size: 0.31rem;
      line-height: 0.88rem;
      margin-bottom: 0.19rem;
    }
  }
  .join_btn {
    width: 6.92rem;
    height: 1.15rem;
    font-size: 0.35rem;
    line-height: 1.15rem;
    margin-top: 1.15rem;
  }
  .special_title {
    position: relative;
    z-index: 9;
    margin-bottom: 40px;
    img {
      width: 88px;
      height: 67px;
      display: block;
      position: absolute;
      right: 20px;
      bottom: 0px;
      z-index: 1;
    }
  }
}
</style>